<form [formGroup]="purchaseInfoForm">
  <div class="pad-top-20 row column twelve lg-push-two md-eight md-push-two">
    <h2 class="bold-header" data-cy="vehiclePurchaseInfoSubheading">
      {{ newVehicleDiscountQuestion$ | async }}
    </h2>
    <div class="add-vehicle-title">
      <div class="row vehicle">
        <div class="flex self-center pad-10">
          <div class="self-center pad-right-30" aria-hidden="true">
            <span class="icon-auto"></span>
          </div>
          <div class="self-center">
            <div class="risk-info">
              <div class="caption" dsContent [contentPath]="'policy.newVehicleCaption'"></div>
              <div class="heading" data-cy="vehiclePurchaseInfoRiskDescription">
                {{ vehicleRiskDescription$ | async }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div>
      <fieldset class="radio" data-cy="vehiclePurchaseInfoNewVehicleFieldset">
        <div class="flex items-center">
          <input
            class="margin-right-6"
            type="radio"
            formControlName="isNewVehicleDiscountActive"
            id="isNewVehicleDiscountActive-yes"
            data-cy="vehiclePurchaseInfoNewVehicleRadioYes"
            [value]="'yes'"
          />
          <label
            for="isNewVehicleDiscountActive-yes"
            data-cy="vehiclePurchaseInfoGracePeriodActiveLabel"
          >
            Yes
          </label>
        </div>
        <div class="flex items-center pad-top-10">
          <input
            class="margin-right-6"
            type="radio"
            formControlName="isNewVehicleDiscountActive"
            id="isNewVehicleDiscountActive-no"
            data-cy="vehiclePurchaseInfoNewVehicleRadioNo"
            [value]="'no'"
          />
          <label
            for="isNewVehicleDiscountActive-no"
            data-cy="vehiclePurchaseInfoGracePeriodInactiveLabel"
          >
            No
          </label>
        </div>
      </fieldset>
    </div>
  </div>

  <div class="row column twelve lg-push-two md-eight md-push-two">
    <call-to-action
      displayBackButton="true"
      tertiaryButtonName="Cancel"
      [disabled]="purchaseInfoForm.invalid"
      [primaryButtonName]="(isPartner$ | async) ? 'Next Step' : 'Continue'"
      (primaryEvent)="submitPurchaseInfo()"
      (tertiaryEvent)="cancelEvent.emit(true)"
      (backEvent)="goBackOneStep()"
    ></call-to-action>
  </div>
</form>
